"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFireCustomEvent = exports.isDefaultPrevented = exports.createCustomEvent = exports.CustomEventType = exports.CustomEventTarget = exports.CustomEventContext = void 0;
var _react = require("react");
let CustomEventType = exports.CustomEventType = /*#__PURE__*/function (CustomEventType) {
  CustomEventType["IssueSnapshotClick"] = "issue-snapshot-click";
  CustomEventType["PlacementLinkClick"] = "placement-link-click";
  return CustomEventType;
}({});
let CustomEventTarget = exports.CustomEventTarget = /*#__PURE__*/function (CustomEventTarget) {
  CustomEventTarget["Image"] = "img";
  CustomEventTarget["Link"] = "a";
  return CustomEventTarget;
}({});
const isDefaultFunctionalityPrevented = Symbol("is-default-functionality-prevented");
const createCustomEvent = object => {
  const customEvent = {
    ...object,
    preventDefault: function () {
      this[isDefaultFunctionalityPrevented] = true;
    },
    [isDefaultFunctionalityPrevented]: false
  };
  return customEvent;
};
exports.createCustomEvent = createCustomEvent;
const isDefaultPrevented = event => {
  return event[isDefaultFunctionalityPrevented];
};
exports.isDefaultPrevented = isDefaultPrevented;
const CustomEventContext = exports.CustomEventContext = (0, _react.createContext)(undefined);
const useFireCustomEvent = () => (0, _react.useContext)(CustomEventContext);
exports.useFireCustomEvent = useFireCustomEvent;
//# sourceMappingURL=CustomEventContext.js.map